import {makeGet} from '@yandex-delivery/utils'

import type {PaymentMethod, PaymentMethodsResponse} from '../types'

export const paymentMethodsGetter = makeGet<PaymentMethodsResponse>()
export const paymentMethodGetter = makeGet<PaymentMethod>()
